import { DefaultButton } from "@/components/buttons/DefaultButton";

interface AdStudioFooterProps {
  totalImages: number;
  totalCredits: number;
  canGenerate: boolean;
  onGenerate: () => void;
}

export function AdStudioFooter({
  totalImages,
  totalCredits,
  canGenerate,
  onGenerate,
}: AdStudioFooterProps) {
  return (
    <div className="px-8 py-6 border-t border-gray-100 bg-gray-50">
      <div className="flex flex-col items-center gap-2">
        <DefaultButton
          title={`Generar ${totalImages} Imágenes • ${totalCredits}`}
          onClick={onGenerate}
          disabled={!canGenerate}
          className="w-full"
        />
        <p className="text-xs text-gray-500">
          Selecciona al menos 1 estilo
        </p>
      </div>
    </div>
  );
}

